'use strict';

var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/containers/soapbox.tsx";
import "core-js/modules/web.dom-collections.iterator.js";

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import { QueryClientProvider } from '@tanstack/react-query';
import classNames from 'clsx';
import React, { useState, useEffect } from 'react';
import { IntlProvider } from 'react-intl';
import { Provider } from 'react-redux';
import { BrowserRouter, Switch, Redirect, Route } from 'react-router-dom'; // @ts-ignore: it doesn't have types

import { ScrollContext } from 'react-router-scroll-4';
import { loadInstance } from 'soapbox/actions/instance';
import { fetchMe } from 'soapbox/actions/me';
import { loadSoapboxConfig, getSoapboxConfig } from 'soapbox/actions/soapbox';
import { fetchVerificationConfig } from 'soapbox/actions/verification';
import * as BuildConfig from 'soapbox/build-config';
import GdprBanner from 'soapbox/components/gdpr-banner';
import Helmet from 'soapbox/components/helmet';
import LoadingScreen from 'soapbox/components/loading-screen';
import AuthLayout from 'soapbox/features/auth-layout';
import EmbeddedStatus from 'soapbox/features/embedded-status';
import PublicLayout from 'soapbox/features/public-layout';
import BundleContainer from 'soapbox/features/ui/containers/bundle-container';
import { ModalContainer, NotificationsContainer, OnboardingWizard, WaitlistPage } from 'soapbox/features/ui/util/async-components';
import { createGlobals } from 'soapbox/globals';
import { useAppSelector, useAppDispatch, useOwnAccount, useFeatures, useSoapboxConfig, useSettings, useTheme, useLocale } from 'soapbox/hooks';
import MESSAGES from 'soapbox/locales/messages';
import { queryClient } from 'soapbox/queries/client';
import { useCachedLocationHandler } from 'soapbox/utils/redirect';
import { generateThemeCss } from 'soapbox/utils/theme';
import { checkOnboardingStatus } from '../actions/onboarding';
import { preload } from '../actions/preload';
import ErrorBoundary from '../components/error-boundary';
import UI from '../features/ui';
import { store } from '../store'; // Configure global functions for developers

createGlobals(store); // Preload happens synchronously

store.dispatch(preload()); // This happens synchronously

store.dispatch(checkOnboardingStatus());
/** Load initial data from the backend */

const loadInitial = () => {
  // @ts-ignore
  return async (dispatch, getState) => {
    // Await for authenticated fetch
    await dispatch(fetchMe()); // Await for feature detection

    await dispatch(loadInstance()); // Await for configuration

    await dispatch(loadSoapboxConfig());
    const state = getState();
    const soapboxConfig = getSoapboxConfig(state);
    const pepeEnabled = soapboxConfig.getIn(['extensions', 'pepe', 'enabled']) === true;

    if (pepeEnabled && !state.me) {
      await dispatch(fetchVerificationConfig());
    }
  };
};
/** Highest level node with the Redux store. */


const SoapboxMount = () => {
  useCachedLocationHandler();
  const me = useAppSelector(state => state.me);
  const instance = useAppSelector(state => state.instance);
  const account = useOwnAccount();
  const soapboxConfig = useSoapboxConfig();
  const features = useFeatures();
  const waitlisted = account && !account.source.get('approved', true);
  const needsOnboarding = useAppSelector(state => state.onboarding.needsOnboarding);
  const showOnboarding = account && !waitlisted && needsOnboarding;
  const singleUserMode = soapboxConfig.singleUserMode && soapboxConfig.singleUserModeProfile;
  const pepeEnabled = soapboxConfig.getIn(['extensions', 'pepe', 'enabled']) === true; // @ts-ignore: I don't actually know what these should be, lol

  const shouldUpdateScroll = (prevRouterProps, _ref) => {
    var _location$state, _location$state2, _prevRouterProps$loca, _prevRouterProps$loca2;

    let {
      location
    } = _ref;
    return !((_location$state = location.state) !== null && _location$state !== void 0 && _location$state.soapboxModalKey && ((_location$state2 = location.state) === null || _location$state2 === void 0 ? void 0 : _location$state2.soapboxModalKey) !== (prevRouterProps === null || prevRouterProps === void 0 ? void 0 : (_prevRouterProps$loca = prevRouterProps.location) === null || _prevRouterProps$loca === void 0 ? void 0 : (_prevRouterProps$loca2 = _prevRouterProps$loca.state) === null || _prevRouterProps$loca2 === void 0 ? void 0 : _prevRouterProps$loca2.soapboxModalKey));
  };
  /** Render the onboarding flow. */


  const renderOnboarding = () => /*#__PURE__*/React.createElement(BundleContainer, {
    fetchComponent: OnboardingWizard,
    loading: LoadingScreen,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 105,
      columnNumber: 5
    }
  }, Component => /*#__PURE__*/React.createElement(Component, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 106,
      columnNumber: 23
    }
  }));
  /** Render the auth layout or UI. */


  const renderSwitch = () => /*#__PURE__*/React.createElement(Switch, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 112,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(Redirect, {
    from: "/v1/verify_email/:token",
    to: "/verify/email/:token",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 113,
      columnNumber: 7
    }
  }), pepeEnabled ? /*#__PURE__*/React.createElement(Redirect, {
    from: "/signup",
    to: "/verify",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 118,
      columnNumber: 9
    }
  }) : /*#__PURE__*/React.createElement(Redirect, {
    from: "/verify",
    to: "/signup",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 120,
      columnNumber: 9
    }
  }), waitlisted && /*#__PURE__*/React.createElement(Route, {
    render: props => /*#__PURE__*/React.createElement(BundleContainer, {
      fetchComponent: WaitlistPage,
      loading: LoadingScreen,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 125,
        columnNumber: 11
      }
    }, Component => /*#__PURE__*/React.createElement(Component, _extends({}, props, {
      account: account,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 126,
        columnNumber: 29
      }
    }))),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 124,
      columnNumber: 9
    }
  }), !me && (singleUserMode ? /*#__PURE__*/React.createElement(Redirect, {
    exact: true,
    from: "/",
    to: "/".concat(singleUserMode),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 133,
      columnNumber: 11
    }
  }) : /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: "/",
    component: PublicLayout,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 134,
      columnNumber: 11
    }
  })), !me && /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: "/",
    component: PublicLayout,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 137,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: "/about/:slug?",
    component: PublicLayout,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 140,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/login",
    component: AuthLayout,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 141,
      columnNumber: 7
    }
  }), features.accountCreation && instance.registrations && /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: "/signup",
    component: AuthLayout,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 144,
      columnNumber: 9
    }
  }), pepeEnabled && /*#__PURE__*/React.createElement(Route, {
    path: "/verify",
    component: AuthLayout,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 148,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/reset-password",
    component: AuthLayout,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 151,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/edit-password",
    component: AuthLayout,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 152,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/invite/:token",
    component: AuthLayout,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 153,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/",
    component: UI,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 155,
      columnNumber: 7
    }
  }));
  /** Render the onboarding flow or UI. */


  const renderBody = () => {
    if (showOnboarding) {
      return renderOnboarding();
    } else {
      return renderSwitch();
    }
  };

  return /*#__PURE__*/React.createElement(ErrorBoundary, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 169,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(BrowserRouter, {
    basename: BuildConfig.FE_SUBDIRECTORY,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 170,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(ScrollContext, {
    shouldUpdateScroll: shouldUpdateScroll,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 171,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(Switch, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 172,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(Route, {
    path: "/embed/:statusId",
    render: props => /*#__PURE__*/React.createElement(EmbeddedStatus, {
      params: props.match.params,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 175,
        columnNumber: 34
      }
    }),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 173,
      columnNumber: 13
    }
  }), /*#__PURE__*/React.createElement(Redirect, {
    from: "/@:username/:statusId/embed",
    to: "/embed/:statusId",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 177,
      columnNumber: 13
    }
  }), /*#__PURE__*/React.createElement(Route, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 179,
      columnNumber: 13
    }
  }, renderBody(), /*#__PURE__*/React.createElement(BundleContainer, {
    fetchComponent: NotificationsContainer,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 182,
      columnNumber: 15
    }
  }, Component => /*#__PURE__*/React.createElement(Component, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 183,
      columnNumber: 33
    }
  })), /*#__PURE__*/React.createElement(BundleContainer, {
    fetchComponent: ModalContainer,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 186,
      columnNumber: 15
    }
  }, Component => /*#__PURE__*/React.createElement(Component, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 187,
      columnNumber: 31
    }
  })), /*#__PURE__*/React.createElement(GdprBanner, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 190,
      columnNumber: 15
    }
  }))))));
};

/** Initial data loader. */
const SoapboxLoad = _ref2 => {
  let {
    children
  } = _ref2;
  const dispatch = useAppDispatch();
  const me = useAppSelector(state => state.me);
  const account = useOwnAccount();
  const swUpdating = useAppSelector(state => state.meta.swUpdating);
  const locale = useLocale();
  const [messages, setMessages] = useState({});
  const [localeLoading, setLocaleLoading] = useState(true);
  const [isLoaded, setIsLoaded] = useState(false);
  /** Whether to display a loading indicator. */

  const showLoading = [me === null, me && !account, !isLoaded, localeLoading, swUpdating].some(Boolean); // Load the user's locale

  useEffect(() => {
    MESSAGES[locale]().then(messages => {
      setMessages(messages);
      setLocaleLoading(false);
    }).catch(() => {});
  }, [locale]); // Load initial data from the API

  useEffect(() => {
    dispatch(loadInitial()).then(() => {
      setIsLoaded(true);
    }).catch(() => {
      setIsLoaded(true);
    });
  }, []); // intl is part of loading.
  // It's important nothing in here depends on intl.

  if (showLoading) {
    return /*#__PURE__*/React.createElement(LoadingScreen, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 245,
        columnNumber: 12
      }
    });
  }

  return /*#__PURE__*/React.createElement(IntlProvider, {
    locale: locale,
    messages: messages,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 249,
      columnNumber: 5
    }
  }, children);
};

/** Injects metadata into site head with Helmet. */
const SoapboxHead = _ref3 => {
  let {
    children
  } = _ref3;
  const locale = useLocale();
  const settings = useSettings();
  const soapboxConfig = useSoapboxConfig();
  const darkMode = useTheme() === 'dark';
  const themeCss = generateThemeCss(soapboxConfig);
  const bodyClass = classNames('bg-white dark:bg-gray-800 text-base h-full', {
    'no-reduce-motion': !settings.get('reduceMotion'),
    'underline-links': settings.get('underlineLinks'),
    'dyslexic': settings.get('dyslexicFont'),
    'demetricator': settings.get('demetricator')
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Helmet, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 277,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement("html", {
    lang: locale,
    className: classNames('h-full', {
      dark: darkMode
    }),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 278,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement("body", {
    className: bodyClass,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 279,
      columnNumber: 9
    }
  }), themeCss && /*#__PURE__*/React.createElement("style", {
    id: "theme",
    type: "text/css",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 280,
      columnNumber: 22
    }
  }, ":root{".concat(themeCss, "}")), darkMode && /*#__PURE__*/React.createElement("style", {
    type: "text/css",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 281,
      columnNumber: 22
    }
  }, ':root { color-scheme: dark; }'), /*#__PURE__*/React.createElement("meta", {
    name: "theme-color",
    content: soapboxConfig.brandColor,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 282,
      columnNumber: 9
    }
  })), children);
};
/** The root React node of the application. */


const Soapbox = () => {
  return /*#__PURE__*/React.createElement(Provider, {
    store: store,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 293,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(QueryClientProvider, {
    client: queryClient,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 294,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(SoapboxHead, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 295,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(SoapboxLoad, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 296,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(SoapboxMount, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 297,
      columnNumber: 13
    }
  })))));
};

export default Soapbox;